import { Component } from '@angular/core';
import { viewerType } from 'ngx-doc-viewer';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;
@Component({
    selector: 'app-view-modal',
    templateUrl: './view-modal.component.html',
    styleUrls: ['./view-modal.component.scss'],
    standalone: false
})

/**
 * Input for viewModal
 * let file = {
      fileName: itemName,
      fileUrl: this.fileUrl,
    }; 
 */
export class ViewModalComponent {
  public heading: string = '';
  public fileUrl: any = null;
  public fileViewer: viewerType | 'image' = 'google';
  public format: string = '';
  togglepicPreview: boolean = false;
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  viewFile(file: any) {
    this.fileUrl = file.fileUrl;
    this.heading = file.fileName;
    this.format = this.getFileExtension(file.fileName);
    if (['.doc', '.docx', '.ppt', '.pptx'].includes(this.format)) {
      this.fileViewer = 'office';
    } else if (['.pdf', '.txt'].includes(this.format)) {
      this.fileViewer = 'url'; //url used as a false name for showing iframe
      this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.fileUrl
      ); // only pdf and txt files need sanitization and other files will not work on sanitize
    } else if (['.jpg', '.jpeg', '.png'].includes(this.format)) {
      this.fileViewer = 'image';
    }
  }

  closeModal() {
    (<any>$('#sharedViewModal')).modal('hide');
  }

  fnCall() {
    this.togglepicPreview = !this.togglepicPreview;
  }

  openModal(file: any) {
    this.fileUrl = null;
    this.viewFile(file);
    (<any>$('#sharedViewModal')).modal('show');
  }

  getFileExtension(fileName: string): string {
    // Get the last index of the dot character to extract the file extension
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) {
      return ''; // Return an empty string if no file extension found
    }
    return fileName.substring(dotIndex).toLowerCase();
  }
}
